import type { DimensionKey } from '@hub/bearing-hub/common/types';
import { dimensionKey } from '@hub/bearing-hub/common/constants';
import type {
  IbhIcnPartsResponseDtoIcnProcedureEnum,
  IbhIcnProcedure,
  IbhMaterialLightResponseDtoProcedureEnum,
  IbhProcedure,
} from '@igus/iglidur-bearing-hub-api/src/data-contracts';
import {
  IbhMaterialResponseDtoProcedureEnum,
  IbhProductionMethods,
  IbhShape,
} from '@igus/iglidur-bearing-hub-api/src/data-contracts';
import type { TFunction } from 'next-i18next';

export function getDimensionLabel(dimension: DimensionKey, shape: IbhShape) {
  switch (dimension) {
    case dimensionKey.b2d3:
      return 'b2.2';
    case dimensionKey.b2d4:
      return 'b2.1';
    case dimensionKey.slotAngle:
      return 'T (°)';
    case dimensionKey.b1:
      return shape === IbhShape.T ? 's' : dimension;
    default:
      return dimension;
  }
}

export const getProcedureText = (
  productionMethod: IbhProductionMethods,
  t: TFunction,
  procedure?:
    | IbhProcedure
    | IbhIcnProcedure
    | IbhMaterialLightResponseDtoProcedureEnum
    | IbhIcnPartsResponseDtoIcnProcedureEnum
): string => {
  const getTranslation = (key: string) =>
    t(`PRODUCTION_METHODS.${key.replace(/-/gi, '_')}`, { ns: 'bearing-hub/bearingHub' });

  if (productionMethod === IbhProductionMethods.SEMIFINISHED && procedure) {
    return getTranslation(String(procedure));
  }

  const translationKey = getTranslation(String(productionMethod));

  if (procedure && productionMethod === IbhProductionMethods.THREEDIMENSIONALPRINT) {
    return `${procedure} ${translationKey}`;
  }
  return translationKey;
};

export const getProductionMethodFromProcedureText = (
  procedure: IbhMaterialResponseDtoProcedureEnum,
  t: TFunction
): string => {
  const translationKeys: Partial<Record<IbhMaterialResponseDtoProcedureEnum, string>> = {
    [IbhMaterialResponseDtoProcedureEnum.CNC]: 'PRODUCTION_METHODS.MECHANICAL_REPROCESSING',
    [IbhMaterialResponseDtoProcedureEnum.WOUND]: 'PRODUCTION_METHODS.WOUND',
    [IbhMaterialResponseDtoProcedureEnum.IM]: 'PRODUCTION_METHODS.MOLD_INJECTION',
  };

  const key = translationKeys[procedure] ?? 'PRODUCTION_METHODS.THREE_DIMENSIONAL_PRINT';

  const prefix = translationKeys[procedure] ? '' : `${procedure} `;

  return prefix + t(key, { ns: 'bearing-hub/bearingHub' });
};
